/**
 * Styles.
 */
import './style.scss';

/**
 * External Dependencies
 */
import React, { useEffect } from 'react';
import _ from 'lodash';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Spinner } from 'reactstrap';

/**
 * Internal Dependencies
 */
import { GET_BALANCE_HISTORY_ORDER } from './graphql';
import { updatePaginatedData } from '../../utils';
import { orderDetails } from '../../actions/order';
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import NavigationTopRight from '../../components/navigation-top-right';

const OrderDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const currentUser = useSelector(state => state.currentUser);
  const updateOrder = useSelector(state => state.updateOrder);

  const { loading, error, data, fetchMore } = useQuery(GET_BALANCE_HISTORY_ORDER, {
    variables: { id }
  });

  const updateData = () => {
    fetchMore({
      variables: { id },
      updateQuery: (previousResult, { fetchMoreResult }) =>
        updatePaginatedData('getBalanceHistory', previousResult, fetchMoreResult),
      notifyOnNetworkStatusChange: true
    });
  };

  const order = _.get(data, 'getBalanceHistory');
  if (order) dispatch(orderDetails(order));

  useEffect(() => {
    updateData();
  }, [updateOrder]);

  if (loading)
    return (
      <div className="fullscreen-div d-flex justify-content-center align-items-center height-100vh">
        <Spinner animation="border" role="status" />
      </div>
    );
  if (error)
    return (
      <div className="fullscreen-div d-flex justify-content-center align-items-center height-100vh">
        {`Error! ${error.message}`}
      </div>
    );
  if (data && !data.getBalanceHistory) {
    window.location.href = process.env.REACT_APP_BASE_URL;
  }

  return (
    <PageWrap>
      <PageTitle
        className="d-sm-block"
        breadcrumbs={{
          '/': currentUser ? currentUser.name : ' ',
          '/orders': 'Order'
        }}
      >
        <Row className="mb-0">
          <Col md="4">
            <h1>{`Order ID: ${order.trackOrderId}`}</h1>
          </Col>
          <Col md="8" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default OrderDetail;
